import { AppNavigation } from '@/components/AppNavigation'
import Logo, { LogoColorVariant } from '@/components/svgs/Logo'
import { HStack } from '@/ui/core/stack'
import { cn } from '@/ui/utils'
import React from 'react'
import { View } from 'react-native'
import { appHeaderStyles } from './AppHeader.styles'

const AppHeader = ({
	className,
	containerClassName,
	logoColor = LogoColorVariant.DARK,
	showNavigation = true,
}: {
	className?: string
	containerClassName?: string
	logoColor?: LogoColorVariant
	showNavigation?: boolean
}) => (
	<HStack className={cn(appHeaderStyles(), className)}>
		<View className={cn('z-30 native:top-6 left-4 p-6', containerClassName)}>
			<Logo color={logoColor} />
		</View>
		{showNavigation && <AppNavigation />}
	</HStack>
)

export { AppHeader }
